import { render, staticRenderFns } from "./mobile-games.vue?vue&type=template&id=75e0b39d&scoped=true"
import script from "./mobile-games.vue?vue&type=script&lang=js"
export * from "./mobile-games.vue?vue&type=script&lang=js"
import style0 from "./mobile-games.vue?vue&type=style&index=0&id=75e0b39d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e0b39d",
  null
  
)

export default component.exports